import { createContext, useContext, useEffect, useState } from 'react';

const PersistantOptionsContext = createContext(null);

interface Options {
  upcomingShowAll: boolean;
  liveClassesShowAll: boolean;
  myTasksShowAll: boolean;
}

export default function PersistantOptionsProvider({ children }) {
  const [options, setOptions] = useState<Options>({
    upcomingShowAll: true,
    liveClassesShowAll: false,
    myTasksShowAll: true,
  });
  const { upcomingShowAll, liveClassesShowAll, myTasksShowAll } = options;

  function setOptionsProp(e, prop) {
    const copyOptions = { ...options };
    copyOptions[prop] = e;
    setOptions(copyOptions);
  }

  useEffect(() => {
    const optionsFromStorage = JSON.parse(localStorage.getItem('options'));
    if (optionsFromStorage) {
      setOptions(optionsFromStorage);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('options', JSON.stringify(options));
  }, [options]);

  return (
    <PersistantOptionsContext.Provider
      value={{
        upcomingShowAll,
        liveClassesShowAll,
        myTasksShowAll,
        setOptionsProp,
      }}
    >
      {children}
    </PersistantOptionsContext.Provider>
  );
}

export const usePersistanOptions = () => useContext(PersistantOptionsContext);
